// Import the functions you need from the SDKs you need
import { initializeApp, getApps } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getMessaging, isSupported as isMessagingSupported } from 'firebase/messaging';

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyDJJz3UCcitg6P1UL2SBDkizKJRZ_Z6umg",
    authDomain: "keepspot-84370.firebaseapp.com",
    projectId: "keepspot-84370",
    storageBucket: "keepspot-84370.firebasestorage.app",
    messagingSenderId: "872851386403",
    appId: "1:872851386403:web:9d1e90903c7f9c6f084196"
};

// VAPID public key from Firebase console > Cloud Messaging > Web Push certificates
export const firebaseVapidKey = 'BPEZoZwx3iTk-Blxk2joesM6HviTiVEZGTZvndTxZ-evU_CJWWTJHpydu3Rgdip600fD0gASTub3CHfDcoq_tXU';

// Initialize Firebase
// avoid re-initializing if hot-reloading or multi-imports
const app = !getApps().length
    ? initializeApp(firebaseConfig)
    : getApps()[0];

export const firebaseApp = app;
export const firebaseConfigPublic = firebaseConfig;
export const firebaseAuth = getAuth(app);
export const firestoreDb = getFirestore(app);

// Lazy-initialized so firebase/messaging (which touches `self`) only loads when called.
let _messaging = null;
export async function getFirebaseMessaging() {
    if (_messaging) return _messaging;
    const supported = await isMessagingSupported();
    if (!supported) return null;
    _messaging = getMessaging(app);
    return _messaging;
}
